import React from "react";
import styles from "./inde.module.css";

const Specifications = ({ vehicle }) => {
  const specs = [
    { label: "Make", value: vehicle?.make?.name },
    { label: "Model", value: vehicle?.model?.name },
    { label: "Interior color", value: vehicle?.interior_color?.name },
    { label: "Exterior color", value: vehicle?.exterior_color?.name },
    { label: "Drive type", value: vehicle?.wheel_drive },
    { label: "Transmission", value: vehicle?.transmission?.name },
    { label: "Interior condition", value: vehicle?.interior_condition },
    { label: "Exterior condition", value: vehicle?.exterior_condition },
    { label: "Reg. Year", value: vehicle?.reg_year },
    { label: "Mfg. Year", value: vehicle?.mfg_year },
    { label: "Country", value: vehicle?.country?.name },
    { label: "Mileage", value: vehicle?.mileage },
    { label: "Fuel type", value: vehicle?.fuel?.name },
    { label: "Engine CC.", value: vehicle?.engine_capacity },
    { label: "Doors", value: vehicle?.no_of_doors },
    { label: "Seats", value: vehicle?.no_of_seats },
    { label: "Chassis No.", value: vehicle?.chassis_no },
    { label: "Model code", value: vehicle?.model_code?.name }
  ];

  return (
    <div className={styles.specContainer}>
      <h2 className={styles.specTitle}>Specifications</h2>

      <div className={styles.specList}>
        {specs.map((item, index) => (
          <div className={styles.specRow} key={index}>
            <span className={styles.specLabel}>{item.label}</span>
            <span className={styles.specValue}>{item.value || "-"}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Specifications;